// @ts-check
import Icon from 'components/base/Icon';
import { useHistory } from 'react-router';
import AppRouter from 'common/AppRouter';
import { LBButton } from '@linearb/buzz';

const SettingsButton = () => {
  const history = useHistory();

  const onClick = () =>
    history.replace(AppRouter.PROJECTS_RESOURCE_ALLOCATION_CONFIG.path);

  return (
    <LBButton variant='outline' data-cy='btn-ra-settings' onClick={onClick}>
      <Icon name='Pencil' /> Configure
    </LBButton>
  );
};

export default SettingsButton;
